module.exports = __webpack_public_path__ + "static/tiskPdf-949e6170bffb4ac13fc0bf984ce635f5.png";